import createTypes from 'redux-create-action-types';

export default createTypes('ADD_MENTION_URL', 'REMOVE_MENTION_URL');
